import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTheme } from 'styled-components';
import { srri, getProductTypeLabel, getFundsListPath } from '@finect/front-resources/Products';
import { Tiles } from '../../Tiles';
import { BackgroundImageCard } from '../../Cards';
import { Section } from '../../Section';
import { breakPointsSet3 } from '../../Carousel';
export var FundSRRICarousel = function FundSRRICarousel(_ref) {
  var productType = _ref.productType;
  var literal = getProductTypeLabel(productType, 'shortPlural', 'none');
  var plural = getProductTypeLabel(productType, 'shortPlural', 'lowercase');
  var theme = useTheme();
  return React.createElement(Section, {
    bottomMargin: true,
    title: "".concat(literal, " por nivel de riesgo"),
    subtitle: "Los ".concat(plural, " clasificados seg\xFAn el riesgo que quieras asumir")
  }, React.createElement(Tiles, {
    breakpoints: breakPointsSet3
  }, srri.map(function (srriLevel, index) {
    return React.createElement(BackgroundImageCard, {
      key: index,
      verticalAlign: "bottom",
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      color: "#fff",
      backgroundImage: srriLevel.backgroundImage,
      link: getFundsListPath(theme, productType, {
        srri: srriLevel.risk
      }),
      title: srriLevel.label
    });
  })));
};